import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Row, Col, Spin, Form, Input, Button, Modal } from 'antd';
import IntlMessages from "../../../components/utility/intlMessages";
import { DvAxiosRequestEx, DvIntlMessages } from "../../../components/utility/dvGeneralUtilities";
import systemActions from '../../../redux/systemInfos/actions';
import EditUserForm from '../../Clinics/ClinicDetails/editUserForm';
import { useEffect, useState } from 'react';

const { changeUserPassword, getUserPermissions, changeUserStatus } = systemActions;

function UserDetailsGeneral({
  data,
  loading,
  userPermissions,
  getUserPermissions,
  changeUserPassword,
  changeUserStatus,
}) {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);

  useEffect(() => {
    if(data?.id === undefined) return;
    getUserPermissions(data.id);
  }, [data.id]);

  const onFinish = (values) => {
    delete values.confirm;
    const userId = data.id;
    changeUserPassword(userId, values);
  };

  function handleChangeUserStatus(status) {
    const userId = data.id;
    changeUserStatus(userId, status);
  }

  function factoryDeActivateButton() {
    return (<Row style={{ marginTop: "25px" }}>
      <Col>
        <Button type="primary" danger onClick={() => handleChangeUserStatus('deactivate')}>
          <IntlMessages id="general.deactivate" />
        </Button>
      </Col>
    </Row>)
  }

  function factoryActivateButton() {
    return (<Row style={{ marginTop: "25px" }}>
      <Col>
        <Button type="primary" onClick={() => handleChangeUserStatus('activate')}>
          <IntlMessages id="general.activate" />
        </Button>
      </Col>
    </Row>);
  }

  function getRenderActivateDeActivateButton() {
    return data.isActive ? factoryDeActivateButton() : factoryActivateButton();
  }

  const renderActivateDeActivateButton = getRenderActivateDeActivateButton();

  const renderField = (textId, value, headerStyles) => {
    return <div>
            <span style={{width: 120, display: 'inline-block', textAlign: 'right', ...headerStyles}} >
              <IntlMessages id={textId} /> : 
            </span>
            &nbsp;&nbsp;
            <b style={{display: 'inline-block'}}> {value === null || value === undefined ? '-' : value}</b>
          </div>;
  };

  return (
    <Spin spinning={loading}>
      <Row style={{ marginTop: '25px' }} gutter={[16, 16]} align='middle'>
        <Col span={24}>
          {renderField('clinicsPage.table.id', data.id)}
          {renderField('general.firstName', data.firstName)}
          {renderField('general.lastName', data.lastName)}
          {renderField('general.specialty', data.specialty)}
          {renderField('general.role', data.roles?.map(r => r?.name))}
          {renderField('general.email', data.email)}
          {renderField('general.phone', data.phone)}
          {renderField('clinicPage.clinicDetails.numOfPatients', data.numOfPatients)}
          {renderField('userDetails.lastLoginAt', data.lastLoginAt)}
          {renderField('userDetails.permissions', userPermissions?.map((p, ix) => (<div key={ix}><span>→ {p}</span></div>)), {verticalAlign: 'top'})}
        </Col>
        <Col span={24}>
          <Button type="primary" htmlType="button" onClick={() => setIsEditModalVisible(true)}>
            <IntlMessages id="userDetails.editUser" />
          </Button>
        </Col>


        <hr className='full-width'/>

        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <Form name="resetUserPassword" onFinish={onFinish}>
            <Form.Item
              name="password"
              label={<IntlMessages id="signin.password" />}
              rules={[
                {
                  required: true,
                  message: DvIntlMessages('registration.passwordRequired'),
                },
                {
                  min: 6,
                  message: DvIntlMessages("registration.passwordMinimum"),
                }
              ]}
              hasFeedback
            >
              <Input.Password
                style={{ marginTop: '10px' }}
                id="real-password"
                autoComplete="new-password"
                placeholder={DvIntlMessages("signin.password")} />
            </Form.Item>

            <Form.Item
              name="confirm"
              label={<IntlMessages id="registration.passwordConfirm" />}
              dependencies={['password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: DvIntlMessages('registration.passwordConfirmRequired')
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(DvIntlMessages('registration.passwordConfirmIncorrect'));
                  },
                }),
              ]}
            >
              <Input.Password
                  style={{ marginTop: '10px' }}
                  autoComplete="confirm-password"
                  placeholder={DvIntlMessages("registration.passwordConfirm")} />
            </Form.Item>

            <Row gutter={[16, 16]} style={{ marginTop: "25px" }}>
              <Col>
                <Button type="primary" htmlType="submit">
                  <IntlMessages id="userDetails.changeUserPassword" />
                </Button>
              </Col>
            </Row>

            {renderActivateDeActivateButton}

          </Form>
        </Col>

          <Modal open={isEditModalVisible} footer={null} onCancel={() => setIsEditModalVisible(false)} destroyOnClose={true}>
            <EditUserForm userId={data.id} closeModal={() => setIsEditModalVisible(false)}/>
          </Modal>

      </Row>
    </Spin>
  )
}
UserDetailsGeneral.propTypes = {
  data: PropTypes.object.isRequired,
  
  loading: PropTypes.number.isRequired,
  userPermissions: PropTypes.array.isRequired,
  changeUserStatus: PropTypes.func.isRequired,
  changeUserPassword: PropTypes.func.isRequired,
};

UserDetailsGeneral.defaultProps = {
  data: {}
}

const mapActionsToProps = {
  changeUserStatus,
  changeUserPassword,
  getUserPermissions,
};

function mapStateToProps(state) {
  return {
    loading: state.SystemInfos.get('loading'),
    userPermissions: state.SystemInfos.get('userPermissions'),
  };
}

const connectedUserDetailsGeneral = connect(mapStateToProps, mapActionsToProps)(UserDetailsGeneral);
export default connectedUserDetailsGeneral;
